import DBTable from "../../../../../../component/global/DBTable/DBTable";
import {ReactComponent as FeedCoin} from "../../../../../../asset/icons/three-coin-icon.svg";
import DetailStatusDateFilter from "./DetailStatusDateFilter";
import DetailStatusSearch from "./DetailStatusSearch";
import DetailStatusFilterBase from "./DetailStatusFilterBase";
import {useEffect, useMemo, useState} from "react";
import {get, post} from "../../../../../../controlers/global/ConfigRequest";
import {DEACTIVATE_USED_DISCOUNT_CARD, USED_DISCOUNT_CARD_LIST} from "../../../../../../helperData/ApiAddress";
import {Spinner} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import moment from "jalali-moment";

function DetailStatus({id, show}) {
  const {t} = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])
  const [filterBase, setFilterBase] = useState(null)
  const [textSearch, setTextSearch] = useState('')
  const [refresh, setRefresh] = useState(false)

  const headers = useMemo(() => {
    return [
      {
        id: 'row',
        title: t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Table.Row'),
        gridTemplateColumns: '55px'
      },
      {
        id: 'username',
        title: t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Table.Username'),
        gridTemplateColumns: '100px'
      },
      {
        id: 'phoneNumber',
        title: t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Table.PhoneNumber'),
        gridTemplateColumns: '100px',
        // numberWithComma: true,
      },
      {
        id: 'uniCode',
        title: t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Table.UniCode'),
        gridTemplateColumns: '100px',
        rowStyle: {textAlign: 'center'},
        // numberWithComma: true,
      },
      {
        id: 'buyDate',
        title: t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Table.BuyDate'),
        gridTemplateColumns: '100px',
        rowStyle: {textAlign: 'center', whiteSpace: 'break-spaces'},
        // headerStyle: {},
      },
      {
        id: 'usedDate',
        title: t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Table.UsedDate'),
        gridTemplateColumns: '100px',
        rowStyle: {textAlign: 'center', whiteSpace: 'break-spaces'},
      },
      {
        id: 'rate',
        title: t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Table.Rate'),
        gridTemplateColumns: '100px',
        // rowStyle: {textAlign: 'center'},
      },
      {
        id: 'status',
        title: t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Table.Status'),
        gridTemplateColumns: '120px',
        rowStyle: {textAlign: 'center'},
      },
    ]
  }, [t])

  useEffect(() => {
    if (show) {
      setIsLoading(true)
      let params = {discount_card: id}
      if (filterBase && textSearch) {
        params[filterBase] = textSearch
      }
      get(USED_DISCOUNT_CARD_LIST, params)
        .then(res => {
          console.log('res', res)
          setData(res.results)
        })
        .finally(() => setIsLoading(false))
    }
  }, [filterBase, id, show, textSearch, refresh])

  const rows = useMemo(() => {
    function changeStatus(id) {
      return (
        <select
          className='change-status-select-table'
          onChange={() => {
            post(DEACTIVATE_USED_DISCOUNT_CARD.replace('{id}', id))
              .then(res => console.log('changeStatus res', res))
              .catch(err => console.log('changeStatus err', err))
              .finally(() => setRefresh(prevState => !prevState))
          }}
        >
          <option selected disabled>{t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Open')}</option>
          <option value="2">{t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Used')}</option>
        </select>
      )
    }

    return data.map((item, index) => {
      return {
        row: index + 1,
        username: item?.user?.first_name + ' ' + item?.user?.last_name,
        phoneNumber: item?.user?.phone_number?.replace('+', '0') || '',
        uniCode: item.code,
        buyDate: item?.created_at ? moment(item?.created_at).format('jYYYY/jMM/jDD HH:MM') : "",
        usedDate: item?.updated_at ? moment(item?.created_at).format('jYYYY/jMM/jDD HH:MM') : "",
        rate: <div className='detail-status-feedCoin'>{item?.coin} <FeedCoin/></div>,
        status: item?.active ? changeStatus(item.id) : t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.Used'),
      }
    })
  }, [data, t])


  function showContent() {
    if (isLoading) return <Spinner animation="border" style={{marginTop: 20}}/>
    // if (!data?.length) return <div>{t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.NotFound')}</div>
    return (
      <>
        <div className='detail-status-filter'>
          <DetailStatusSearch
            value={textSearch}
            onClick={(inputValue) => {
              setTextSearch(inputValue)
              // console.log('inputValue', inputValue)
            }}
          />
          <DetailStatusFilterBase
            value={filterBase}
            onChange={(e) => {
              setFilterBase(e.target.value)
            }}
          />
          <DetailStatusDateFilter/>
        </div>
        {data?.length ?
          <DBTable width={860} headers={headers} rows={rows}/> :
          <div>{t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.NotFound')}</div>
        }
      </>
    )
  }

  return (
    <div className='offer-management-detail-status-container'>
      {showContent()}
    </div>
  );
}

export default DetailStatus;
